import { createAsyncThunk } from '@reduxjs/toolkit';

import axios from 'config/axios';
import { setAgents, setFIMActivities, setMalwareActivities, setMitre, setSecurityAlerts, setVulnerabilities } from 'stores/modules/soc/agentreducer';

export const fetchAgents = createAsyncThunk('socData/fetchAgents', async (params, { dispatch }) => {
  try {
    dispatch(setAgents([]));
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getAgentslast24hours`, {
      params: params,
    });
    if (response.status === 200) {
      dispatch(setAgents(response.data));
    }
    else {
    }
  } catch (error) {

  }
});

export const getAgents = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getAgentsByQuery`, {
      params: params,
    });
    if (response.status === 200) {
      return response?.data
    }
    else {

    }
  } catch (error) {

  }
};

export const getAgentsByLastOneDay = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getAgentsBylastOneDay`, {
      params: params,
    });
    if (response.status === 200) {
      return response?.data
    }
    else {

    }
  } catch (error) {

  }
};
export const getSeverityCounts = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getSeverityCountsByAgent`, {
      params: params,
    });
    if (response.status === 200) {
      return response?.data;
    }
    else {

    }
  } catch (error) {

  }
};

export const getAllSeverityData = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getallSeveritiesbyagent`, {
      params: params,
    });
    if (response.status === 200) {
      return response?.data
    }
    else {

    }
  } catch (error) {

  }
};

export const getThreatHuntingAlerts = createAsyncThunk('socData/getThreatHuntingDetails', async ({ params }, { dispatch }) => {
  try {
    dispatch(setSecurityAlerts([]));
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getThreatHuntinginfoByAgent`, {
      params: params,
    });
    if (response.status === 200) {
      dispatch(setSecurityAlerts(response.data));
    }
    else {
    }
  } catch (error) {

  }
});
export const getAlerts = async ({ params }) => {
  try {

    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getThreatHuntingInfo`, {
      params: params,
    });
    if (response.status === 200) {
      return response.data;
    }
    else {
    }
  } catch (error) {

  }
};

export const getThreatHuntingDetails = async (body) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getThreatHuntingDetails`, body, {
      'Content-Type': 'application/json',
    });
    if (response.status === 200) {

      return response.data
    }
  } catch (error) {

  }
}

export const downloadAlertsByAgent = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/downloadAlerts`, { params: params })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {

  }
}

export const getSingleAlert = async ({ params }) => {
  try {

    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getAlertById`, {
      params: params,
    });
    if (response.status === 200) {
      return response.data;
    }
    else {
    }
  } catch (error) {

  }
}

export const getMitreGraphDetails = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getMitreMappingdataByAgent`, {
      params: params,
    });
    if (response.status === 200) {
      return response?.data
    }
    else {

    }
  } catch (error) {

  }
};

export const getSCAOverallScore = async (id, env) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getSCALatestDataByAgent?agentId=${id}&&soc_env=${env}`);
    if (response.status === 200) {
      return response?.data
    }
  } catch (error) {
  }
}

export const getMitreAlerts = createAsyncThunk('socData/getMitreAlerts', async ({ params }, { dispatch }) => {
  try {
    dispatch(setMitre([]));
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getMitreSecurityAlertsbyAgent`, {
      params: params,
    });
    if (response.status === 200) {
      dispatch(setMitre(response.data));
    }
    else {
    }
  } catch (error) {

  }
});


export const getVulnerabiltyGraphDetails = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getVulnerabilityAlertsAnalysisbyAgent`, {
      params: params,
    });
    if (response.status === 200) {
      return response?.data
    }
  } catch (error) {
  }
}
export const getVulnerabilityDetails = createAsyncThunk('socData/getVulnerabilityDetails', async ({ params }, { dispatch }) => {
  try {
    dispatch(setMitre([]));
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getVulnerabilityAlertsbyAgent`, {
      params: params,
    });
    if (response.status === 200) {
      dispatch(setVulnerabilities(response.data));
    }
    else {
    }
  } catch (error) {

  }
});


export const getSCAReportByAgent = async ({ params }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getSCAreportbyAgent`, {
      params: params
    });
    if (response.status === 200) {
      return response?.data?.data;
    }
  } catch (error) {
  }
}

export const getFIMGraphDetails = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getFIMAnalysisbyAgent`, {
      params: params,
    });
    if (response.status === 200) {
      return response?.data
    }
  } catch (error) {
  }
}


export const getFIMActivitiesInformation = createAsyncThunk('socData/getFIMActivities', async ({ params }, { dispatch }) => {
  try {
    dispatch(setMitre([]));
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getFIMActivitiesbyAgent`, {
      params: params,
    });
    if (response.status === 200) {
      dispatch(setFIMActivities(response.data));
    }
    else {
    }
  } catch (error) {

  }
});

export const getMalwareActivitiesInformation = createAsyncThunk('socData/getMalwareActivities', async ({ params }, { dispatch }) => {
  try {
    dispatch(setMitre([]));
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getMaliciousActivitiesbyAgent`, {
      params: params,
    });
    if (response.status === 200) {
      dispatch(setMalwareActivities(response.data));
    }
    else {
    }
  } catch (error) {

  }
});


export const getMalwareDetectionGraphDetails = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getMaliciousActivityAnalysisbyAgent`, {
      params: params,
    });
    if (response.status === 200) {
      return response?.data
    }
  } catch (error) {
  }
}

export const getSOCGroupValidation = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getGroupByName`, {
      params: params,
    });
    if (response.status === 200) {
      return response?.data
    }
  } catch (error) {
  }
}

export const getSOCEnvironment = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getSocEnvByQuery`, {
    });
    if (response.status === 200) {
      return response?.data
    }
  } catch (error) {
  }
}

export const getTopAgentsByGroup = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getTopAgentsbygroup`, {
      params: params
    });
    if (response.status === 200) {
      return response?.data
    }
  } catch (error) {
  }
}

export const getOverAllMitreGraphDetails = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getMitreMappingDatabygroup`, {
      params: params
    });
    if (response.status === 200) {
      return response?.data
    }
  } catch (error) {
  }
}

export const getSeverityByGroup = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getSeverityDatabygroup`, {
      params: params
    });
    if (response?.status === 200) {
      return response?.data
    }
  } catch (error) {
  }
}

export const getPropertiesByAgentId = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getProperties`, {
      params: params
    });
    if (response?.status === 200) {
      return response?.data
    }
  } catch (error) {
  }
}

export const getAvailableFields = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getAvailableFields`, {
      params: params
    });
    if (response?.status === 200) {
      return response?.data
    }
  } catch (error) {
  }
}


export const updateBulkAlertsById = async (socENV, body) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/updateBulkAlertsById/${socENV}`, body);
    if (response?.status === 200) {
      return response
    }
  } catch (error) {
  }
}

export const getUpdatedTime = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getUpdatedTime`, {
      params: params
    });
    if (response?.status === 200) {
      return response?.data
    }
  } catch (error) {

  }
}

export const getUpdatedTimeByGroup = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getUpdatedTimeByGroup`, {
      params: params
    })
    if (response?.status === 200) {
      return response?.data
    }
  } catch (error) {
  }
}

export const getAutocompleteResults = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SOC_CONFIGURATION_ENDPOINT_URL}/getAutocompleteResults`, {
      params: params,
    });
    if (response.status === 200) {
      return response?.data
    }
    else {

    }
  } catch (error) {
  }
};